import { render, staticRenderFns } from "./Mind.vue?vue&type=template&id=2c4f92a0&scoped=true&"
import script from "./Mind.vue?vue&type=script&lang=js&"
export * from "./Mind.vue?vue&type=script&lang=js&"
import style0 from "./Mind.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Mind.vue?vue&type=style&index=1&id=2c4f92a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4f92a0",
  null
  
)

export default component.exports